import React from 'react';
import { MdEdit } from 'react-icons/md';
import type { IMatrixPositionCriterion } from '../WinnerSelection2.types';

interface IProps {
    criterion: IMatrixPositionCriterion;
    context: string;
    busy: boolean;
    onOpen: (trigger: HTMLElement) => void;
}

const PositionCriterion: React.FC<IProps> = ({ criterion, context, busy, onOpen }) => {
    const { item, value, showComment } = criterion;
    return (
        <button
            type="button"
            className="ws2-cell__tech ws2-cell__tech--editable"
            aria-label={`${item.critName}: ${context}`}
            disabled={busy}
            onClick={(event) => {
                event.stopPropagation();
                onOpen(event.currentTarget);
            }}
        >
            <span className="ws2-cell__tech-line">
                <span className="ws2-cell__criterion-label">{item.critName}</span>
                <span className="ws2-cell__criterion-answer">
                    {value.answer || (value.score != null ? `${value.score} балл.` : 'Нет ответа')}
                </span>
                {value.allowEdit && <MdEdit className="ws2-cell__tech-icon" size="16px" aria-hidden />}
            </span>
            {showComment && value.description && <span className="ws2-cell__comment-inline">{value.description}</span>}
        </button>
    );
};

export default PositionCriterion;
